import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Notification = ({ isNotificationOpen, onClose }) => {
    const [notificationSettings, setNotificationSettings] = useState([
        { id: 1, label: "Email tracking desktop notifications", enabled: true },
        { id: 2, label: "Task assignment email notifications", enabled: true },
        { id: 3, label: "Task reminder email notifications", enabled: false },
        { id: 4, label: "Comment mentions email notifications", enabled: true },
        { id: 5, label: "Overdue tasks email notifications", enabled: false },
        { id: 6, label: "Email reminders", enabled: true },
        { id: 7, label: "Signals Alerts", enabled: false },
    ]);
    const [unreadCount, setUnreadCount] = useState(7);

    const toggleNotification = (id) => {
        setNotificationSettings(prev => 
            prev.map(item => 
                item.id === id ? { ...item, enabled: !item.enabled } : item
            )
        );
        // Add API call here to save the setting
    };

    const markAllAsRead = () => {
        setUnreadCount(0);
        // Add API call here to mark notifications as read
    };

    if (!isNotificationOpen) return null;

    return (
        <>
            {/* Backdrop */}
            <div 
                className="fixed inset-0 z-40 bg-black bg-opacity-50"
                onClick={onClose}
            ></div>
            
            {/* Centered Modal */}
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                <div className="w-full max-w-2xl bg-white rounded-lg shadow-xl border border-gray-200">
                    {/* Header */}
                    <div className="px-6 py-4 border-b border-gray-200">
                        <div className="flex justify-between items-center">
                            <h3 className="text-xl font-semibold text-gray-900">NOTIFICATIONS</h3>
                            <button 
                                onClick={markAllAsRead}
                                className="text-sm text-blue-500 hover:text-blue-700"
                            >
                                Mark all as read
                            </button>
                        </div>
                    </div>

                    {/* Notification Settings */}
                    <div className="max-h-[70vh] overflow-y-auto">
                        {notificationSettings.map((notification) => (
                            <div 
                                key={notification.id} 
                                className="px-6 py-[0.8vw] border-b border-gray-100 last:border-b-0 hover:bg-gray-50"
                            >
                                <div className="flex justify-between items-center">
                                    <span className="text-base text-gray-700">{notification.label}</span>
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input 
                                            type="checkbox" 
                                            className="sr-only peer" 
                                            checked={notification.enabled}
                                            onChange={() => toggleNotification(notification.id)}
                                        />
                                        <div className="w-12 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-500"></div>
                                        <span className="ml-3 text-sm text-gray-500">
                                            {notification.enabled ? 'On' : 'Off'}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Footer */}
                    <div className="px-6 py-3 bg-gray-50 text-right">
                        <button 
                            onClick={()=>onClose()}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Notification;